import { defineComponent as _defineComponent } from 'vue'
import { useRootStore } from '@/store';
import { computed } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Spinner',
  setup(__props) {

const showSpinner = computed(() => useRootStore().spinners > 0);

return { __sfc: true,showSpinner }
}

})